import { styled } from "@mui/material/styles";
import { Card, CardContent, CardMedia, Box, Button } from "@mui/material";

export const CustomCard = styled(Card)(({ theme }) => ({
  width: 250,
  height: 400,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: 16,
  overflow: "hidden",
  boxShadow: "0px 6px 16px rgba(0,0,0,0.15)",
  transition: "all 0.3s ease",
  background: "linear-gradient(145deg, #ffffff, #f9f9f9)",
  margin: "auto",
  "&:hover": {
    transform: "translateY(-8px) scale(1.02)",
    boxShadow: "0px 12px 24px rgba(0,0,0,0.2)",
  },
}));

export const CustomCardMedia = styled(CardMedia)({
  width: "100%",
  height: 180,
  objectFit: "cover",
  objectPosition: "center",
  transition: "transform 0.4s ease",
  "&:hover": { transform: "scale(1.05)" },
});

export const CustomCardContent = styled(CardContent)({
  flexGrow: 1,
  padding: "12px 16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  minHeight: 120,
});

export const CustomCardActions = styled(Box)({
  display: "flex",
  justifyContent: "center",
  padding: "12px",
});

export const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: 30,
  padding: "8px 20px",
  textTransform: "none",
  fontWeight: "bold",
  background: "linear-gradient(45deg, #ff4b2b, #ff416c)",
  color: "#fff",
  "&:hover": {
    background: "linear-gradient(45deg, #e04324, #d9365f)",
  },
}));

export const CustomCardSection = styled(Box)({
  marginTop: "0.5rem",
  width: "100%",
});
